import { Link } from 'react-router-dom';
import { getHotPicks } from '@/utils/drama';

export default function HotRecommend() {
  const list = getHotPicks(6);
  const [first, ...rest] = list;

  return (
    <section className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
      <div className="mb-6">
        <h2 className="flex items-center gap-2 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
          <i className="ri-fire-fill text-primary-500"></i>
          热门推荐
        </h2>
        <p className="mt-1 text-sm text-foreground-600">根据热度与口碑精选的高分剧集</p>
      </div>

      <div className="grid gap-5 lg:grid-cols-2">
        {first && (
          <Link
            to={`/detail/${first.id}`}
            className="group relative block overflow-hidden rounded-lg border border-background-200 cursor-pointer"
          >
            <div className="w-full aspect-[4/3] lg:aspect-auto lg:h-full overflow-hidden bg-background-200">
              <img
                src={first.backdrop || first.poster}
                alt={`${first.title} 推荐海报`}
                title={`${first.title} 高热剧集`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-foreground-950">
                <i className="ri-trophy-line"></i>
                热度榜 TOP 1
              </span>
              <h3 className="mt-3 font-heading text-2xl font-bold text-background-50">
                {first.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-background-200">
                {first.synopsis}
              </p>
              <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-background-200">
                <span className="flex items-center gap-1 text-accent-300">
                  <i className="ri-star-fill"></i>
                  {first.rating.toFixed(1)}
                </span>
                <span>{first.region}</span>
                <span>全 {first.episodes} 集</span>
              </div>
            </div>
          </Link>
        )}

        <div className="flex flex-col gap-3">
          {rest.map((drama, i) => (
            <Link
              key={drama.id}
              to={`/detail/${drama.id}`}
              className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-300 hover:bg-primary-50/40 cursor-pointer"
            >
              <div className="relative h-24 w-16 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-28 md:w-20">
                <img
                  src={drama.poster}
                  alt={`${drama.title} 海报`}
                  title={`${drama.title} 推荐`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="flex h-5 w-5 items-center justify-center rounded bg-primary-100 text-xs font-semibold text-primary-700">
                    {i + 2}
                  </span>
                  <h3 className="truncate font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {drama.title}
                  </h3>
                </div>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {drama.synopsis}
                </p>
                <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
                  <span className="flex items-center gap-1 text-accent-600">
                    <i className="ri-star-fill"></i>
                    {drama.rating.toFixed(1)}
                  </span>
                  {drama.genres.slice(0, 2).map((g) => (
                    <span key={g} className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                      {g}
                    </span>
                  ))}
                  <span>更新至 {drama.latestEpisode} 集</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}